export const SWITCH_TO_PAGE = "router/switchpage";
